/**
 * Exports a boolean value reporting whether the given API is supported or not
 */var isApiSupported=function(a){return"undefined"!=typeof window&&a in window};export default isApiSupported;